import moment from "moment";
import {
  Button,
  Grid,
  Card,
  CardContent,
  Stack,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Chip,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { PurchaseDetailModal } from "./PurchaseDetailModal";
import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  IMPUR01A_Pur_Status_Delete,
  Purchase_Detail_GetRow,
  Purchase_Detail_Update,
  Purchase_Version_GetRow,
} from "../../Server/ApiV2";
import { fAlertToast } from "../../Utility/Utilitys";
import { vRdxUserInfo } from "../../Redux/roStore";
import { confirmAlert } from "react-confirm-alert";

const departmentTextStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 2, // show only 2 lines
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis", // show …
  whiteSpace: "normal", // allow wrapping
};

function Info({ label, value }) {
  return (
    <Stack
      spacing={0.5}
      sx={{
        flexDirection: "row",
        alignItems: "baseline",
        justifyContent: "space-between",
      }}
    >
      <Typography
        variant="caption"
        color="text.primaryCaption"
        sx={{ width: label ? "50%" : "0%" }}
        component="div"
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        sx={{ width: label ? "50%" : "100%" }}
        component="div"
        // style={departmentTextStyle}
      >
        {value}
      </Typography>
    </Stack>
  );
}

export function PurchaseVersionModal({
  open,
  onClose,
  header,
  isMobile,
  UserCd,
  onLoad,
}) {
  const apiRef = useGridApiRef();
  const { Currency } = useSelector((state) => state.SliceDB.value);

  const columns = [
    { field: "TransId", headerName: "Trans ID", width: 65, align: "center" },
    {
      field: "TransDate",
      headerName: "Trans Date",
      width: 95,
      align: "center",
      headerAlign: "center",
      valueFormatter: ({ value }) =>
        moment(value).isValid() ? moment(value).format("DD/MM/YYYY") : "",
    },
    {
      field: "RefTransId",
      headerName: "Order ID",
      width: 75,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "ExchangeRate",
      headerName: "Ex Rate",
      type: "number",
      width: 60,
      align: "center",
    },
    { field: "Vendor", headerName: "Vendor", minWidth: 200, flex: 1 },
    { field: "RefNo", headerName: "Ref No", width: 70, align: "center" },
    {
      field: "RefDate",
      headerName: "Ref Date",
      width: 95,
      align: "center",
      headerAlign: "center",
      valueFormatter: ({ value }) =>
        moment(value).isValid() ? moment(value).format("DD/MM/YYYY") : "",
    },
    { field: "Narration", headerName: "Narration", minWidth: 160, flex: 1 },
    {
      field: "Status",
      headerName: "Status",
      width: 90,
      renderCell: (params) => (
        <span
          style={{
            color: params.value === false ? "orange" : "green",
            fontWeight: "bold",
          }}
        >
          {params.value === false ? "Enter" : "Post"}
        </span>
      ),
    },
    { field: "EnBy", headerName: "Entered By", width: 110 },
    {
      field: "EnDt",
      headerName: "Entry Date",
      width: 100,
      align: "center",
      headerAlign: "center",
      valueFormatter: ({ value }) =>
        moment(value).isValid() ? moment(value).format("DD/MM/YYYY") : "",
    },
  ];

  const initForm = {
    TransId: 0,
    TransDate: moment(),
    Currency: Currency[1]?.UID,
    ExchangeRate: Currency[1]?.ExchangeRate,
    RefNo: "",
    RefDate: moment(),
    Vendor: "",
    Narration: "",
    Status: false,
  };

  const [form, setForm] = useState(initForm);
  const [errors, setErrors] = useState({});
  const [purchaseId, setPurchaseId] = useState(0);
  const [summaryRows, setSummaryRows] = useState([]);
  const [purchaseDetilSummaryRows, setPurchaseDetilSummaryRows] = useState([]);
  const [openDetail, setOpenDetail] = useState(false);
            const vRdxUserInfoObj = vRdxUserInfo();

  const setField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const validate = () => {
    const next = {};
    if (!form.Currency) next.Currency = "Required";
    if (
      form.ExchangeRate === undefined ||
      form.ExchangeRate === null ||
      Number(form.ExchangeRate) <= 0 ||
      Number.isNaN(Number(form.ExchangeRate))
    ) {
      next.exchangeRate = "Enter a valid rate (> 0)";
    }
    if (!String(form.RefNo).trim()) next.RefNo = "Required";
    if (!form.TransDate) next.TransDate = "Required";
    if (!form.RefDate) next.RefDate = "Required";
    if (!String(form.Vendor).trim()) next.Vendor = "Required";
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const filteredPayload =
    purchaseDetilSummaryRows?.length > 0
      ? purchaseDetilSummaryRows
          .filter((obj) => obj.B_Qty > 0) // Filter rows where B_Qty > 0
          .map(
            ({
              id,
              CategoryName,
              MainGroupName,
              SubGroupName,
              B_ReqOty,
              B_PurQty,
              ...rest
            }) => rest
          ) // Remove unnecessary fields
      : [];

  const handleSubmit = async (isApproved) => {
    try {
      if (!validate()) return;
      const {
        Status,
        CurrencyName,
        EnBy,
        EnDt,
        id,
        VendorName,
        B_Ratio,
        ...rest
      } = form;

      const res = await Purchase_Detail_Update({
        ...rest,
        TransDate: moment(rest.TransDate).format("MM/DD/YYYY"),
        RefDate: moment(rest.RefDate).format("MM/DD/YYYY"),
        RefTransId: header?.TransId,
        UserCd,
        isApproved,
        Details: filteredPayload,
      });

      if (res?.status === 200) {
        fAlertToast(
          "SUCCESS",
          `${isApproved ? "Approved" : "Saved"} sucessful`
        );
        setField("TransId", res?.data?.ResultSet[0]?.A_TransId);
        purchaseDetailGetrow(res?.data?.ResultSet[0]?.A_TransId);
        purchaseVersionGetrow();
        onLoad();
      }
    } catch (error) {}
  };

  const purchaseVersionGetrow = async () => {
    const res = await Purchase_Version_GetRow({
      TransId: header?.TransId,
    });
    if (res?.status === 200) {
      const uniqueIdResult = res?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: `purchase-version-row-${i}`,
      }));
      setSummaryRows(uniqueIdResult || []);
    }
  };

  const purchaseversionDelete = async () => {
    try {
      const res = await IMPUR01A_Pur_Status_Delete({
        TransId: header?.TransId,
        UserCd: vRdxUserInfoObj?.UserID,
      });
      if (res?.status === 200) {
        fAlertToast("SUCCESS", "Deleted Successfully");
        await onLoad();
      } else {
        fAlertToast("FAILED", res?.response?.data?.error || res?.message);
      }
    } catch (error) {}
  };


  const purchaseDetailGetrow = async (purchaseIdFromSave = "") => {
    const res = await Purchase_Detail_GetRow({
      ReqTransId: Number(header?.TransId),
      PurTransId: Number(purchaseId ? purchaseId : purchaseIdFromSave),
    });
    if (res?.status === 200) {
      const uniqueIdResult = res?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i,
      }));
      setPurchaseDetilSummaryRows(uniqueIdResult || []);
    }
  };
   
    

  const handleExport = () => {
    apiRef.current.exportDataAsCsv(); // or exportDataAsExcel(), etc.
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  const handleVersionModalClose = () => {
    onClose();
    setForm((prev) => ({ ...prev, ...initForm }));
    setSummaryRows([]);
  };

  const isActionBtnDisabled = useMemo(() => {
    let resultObj = summaryRows.find((obj) => obj?.TransId === form?.TransId);
    return resultObj?.Status;
  }, [summaryRows, form?.TransId]);

  useEffect(() => {
    let currrentObj = Currency?.find((curr) => curr.UID === form?.Currency);
    setForm((prev) => ({
      ...prev,
      Currency: form?.Currency,
      ExchangeRate: currrentObj?.ExchangeRate,
    }));
  }, [form?.Currency]);

 


  useEffect(() => {
    if (open) purchaseVersionGetrow();
  }, [open]);

  return (
    <>
      <Dialog
        fullScreen={isMobile}
        height={isMobile ? "100%" : "auto"}
        maxWidth="lg"
        fullWidth
        open={open}
        onClose={handleVersionModalClose}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "#0d73bb",
            padding: "6px 0px 6px 12px !important",
            color: "#fff",
          }}
        >
          Purchase Version
          <IconButton onClick={handleVersionModalClose} sx={{ color: "#fff" }}>
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{ height: "80vh", padding: { xs: "8px", md: "12px 20px" } }}
        >
          <Card variant="elevation" elevation={5} sx={{ mb: 1.5 }}>
            <CardContent sx={{ padding: "10px !important" }}>
              <Grid container spacing={{ xs: 0.5, md: 1 }}>
                <Grid item xs={12} sm={6} md={3}>
                  <Info label="Order ID" value={header?.TransId} />
                  <Info
                    label="Order Date"
                    value={moment(header?.Date).format("DD/MM/YYYY")}
                  />
                  <Info label="Order Location" value={header?.TransLoc_Name} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Info label="Forecast Days" value={header?.ForecastDays} />
                  <Info
                    label="Expiry Date"
                    value={
                      header?.ExpiredDate
                        ? moment(header.ExpiredDate).isValid()
                          ? moment(header.ExpiredDate).format("DD/MM/YYYY")
                          : ""
                        : ""
                    }
                  />
                  <Info label="PurchaseRatio" value={header?.PurRatio} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Info
                    label="Purchase Status"
                    value={
                      <Chip
                        size="small"
                        color={
                          String(header?.Pur_Status).toUpperCase() === "ENTER"
                            ? "warning"
                            : String(header?.Pur_Status).toUpperCase() ===
                              "DELETE"
                            ? "error"
                            : String(header?.Pur_Status).toUpperCase() ===
                              "POST"
                            ? "success"
                            : ""
                        }
                        label={header?.Pur_Status}
                      />
                    }
                  />
                  <Info
                    label="Close Status"
                    value={
                      <Chip
                        size="small"
                        color={
                          String(header?.Close_Status).toUpperCase() !== "ENTER"
                            ? "success"
                            : "warning"
                        }
                        label={header?.Close_Status}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Info value={header?.GroupName} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Box
            sx={{
              height: { xs: "40vh", sm: "44vh", md: "53vh" },
              // marginTop: "10px",
            }}
          >
            <Button
              variant="contained"
              size="small"
              sx={{ alignContent: "flex-end", mr: 2, mb: 1 }}
              onClick={() => {
                setOpenDetail(true);
                setTimeout(() => {
                  document.getElementsByName("TransDate")[0]?.focus();
                }, 400);
              }}
              disabled={
                header.Pur_Status === "POST" ||
                header.Close_Status === "POST" ||
                header.Pur_Status == "DELETE"
              }
            >
              New
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{ mr: 2, mb: 1 }}
              onClick={handleExport}
            >
              Export
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{ mr: 2, mb: 1 }}
              onClick={handlePrint}
            >
              Print
            </Button>
            <Button
              size="small"
              color="error"
              variant="contained"
              sx={{ mr: 2, mb: 1 }}
              onClick={() =>
                confirmAlert({
                  title: "Delete",
                  message: "Are you sure do you want delete ?",
                  buttons: [
                    {
                      className: "alertBtn",
                      name: "DeletYes",
                      label: "Yes",
                      onClick: () => {
                        purchaseversionDelete();
                      },
                    },
                    {
                      className: "alertBtn",
                      label: "No",
                      onClick: () => "",
                    },
                  ],
                })
              }
              disabled={
                header?.Pur_Status === "POST" || header?.Pur_Status === "DELETE"
              }
            >
              Delete
            </Button>
            <DataGridPro
              apiRef={apiRef}
              rowHeight={30}
              headerHeight={40}
              rows={summaryRows ?? []}
              columns={columns}
              hideFooter
              sx={{
                border: 1,
                borderColor: "primary.light",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#0d73bb",
                  color: "white",
                },
              }}
              onRowClick={(params) => {
                setOpenDetail(true);
                setPurchaseId(params?.row?.TransId);
                setForm((prev) => ({
                  ...prev,
                  ...params?.row,
                }));

                setTimeout(() => {
                  document.getElementsByName("TransDate")[0]?.focus();
                }, 400);
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
      <PurchaseDetailModal
        open={openDetail}
        onClose={() => {
          setOpenDetail(false);
          setForm((prev) => ({ ...prev, ...initForm }));
          setPurchaseId(0);
          setPurchaseDetilSummaryRows([]);
          setErrors({});
        }}
        formState={form}
        setField={setField}
        Currency={Currency}
        RefTransId={header?.TransId}
        handleSubmit={handleSubmit}
        errors={errors}
        setErrors={setErrors}
        header={header}
        isMobile={isMobile}
        isActionBtnDisabled={isActionBtnDisabled}
        onLoad={purchaseDetailGetrow}
        purchaseDetilSummaryRows={purchaseDetilSummaryRows}
        setPurchaseDetilSummaryRows={setPurchaseDetilSummaryRows}
        filteredPayload={filteredPayload}
      />
    </>
  );
}
